module.exports = __webpack_public_path__ + "img/ico_dabiao.d0ae57e8.png";